import CaptainResource from "./captain.resource";

const captainModule = angular
  .module("app.resources.captain", [])
  .service("Captain", CaptainResource);

export default captainModule;



// WEBPACK FOOTER //
// ./src/resources/captain/captain.module.js